import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllHelpSupports extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    userGroupsArr: []
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({exportParams: params})
      let data = await Request.getHelpSupport({
        ...params,
        regExFilters: []
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }
  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateHelpSupport(values)
        } else {
          x = await Request.addHelpSupport(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `HelpSupport Updated Successfully`
              : 'HelpSupport Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteHelpSupport = async data => {
    this.setState({loading: true})
    await Request.deleteHelpSupport(data)

    this.setState({loading: false})

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setHelpSupportData(HelpSupportId) {
    if (HelpSupportId) {
      Request.getHelpSupportByID({id: HelpSupportId}).then(
        ({doc, error, message}) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1'
            })   
            this.props.form.setFieldsValue({
              userGroupIds: doc.userGroupIds,
              question: doc.question,
              answer: doc.answer,
              status: doc.status
            })         

          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  loadDepartments() {
    let params = {
        results: 100,
        sortField: "groupName",
        sortOrder: "ascend",
    };
    Request.loadGroups(params)
        .then((resp) => {
            if (resp) {
              let temp = [{ display: '---Select All---', id:'all'}];
              _.each(resp.data, (vv) => {
                  temp.push({
                      display: vv.groupName,
                      id: vv._id,
                  });
              });
              this.setState({userGroupsArr: temp});
            }
        })
        .catch((err) => {
        });
  }

  componentWillMount() {
    this.loadDepartments()
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {dispatch} = this.props
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    const {userGroupsArr, id} = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'Select Department ',
          key: 'userGroupIds',
          required: true,
          type: 'select',
          mode: 'multiple',
          showSearch: true,
          disabled: false,
          options: userGroupsArr,
          onChange: v => {
            let val = v ? v : [];
            if (v && v.length && v.includes("all")) {
                if (v.length === userGroupsArr.length) {
                    val = [];
                } else {
                    val =  userGroupsArr.slice(1).map(levelOption => levelOption.id);
                }
            }
            this.props.form.setFieldsValue({
              userGroupIds: val
            })
          }
        },
        {
          label: 'Question',
          key: 'question',
          required: true
        },
        {
          label: 'Answer',
          key: 'answer',
          type: 'editor',
          required: true
        },
        {
          label: 'Status',
          key: 'status',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Publish', 'Draft'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({
              status: v
            })
          }
        }
      ]
    };

    const columns = [
      {
        title: 'Department',
        key: 'userGroupNames',
      },
      {
        title: 'Question',
        key: 'question',
      },
      {
        title: 'Answer',
        key: 'answer',
        render: (text, record) => {
          return (
            <div dangerouslySetInnerHTML={{__html: text}}>
            </div>
          )
        }
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'helpSupport.edit'}>
              <Tooltip title="Edit Help & Support">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setHelpSupportData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'helpSupport.delete'}>
              <Tooltip title="Delete Help & Support">
                <Popconfirm
                  title="Are you sure delete this?"
                  onConfirm={() => {
                    this.deleteHelpSupport({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Help & Support `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Rules`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Rule'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllHelpSupports
